import { render, staticRenderFns } from "./profileblock.vue?vue&type=template&id=355f0fce"
import script from "./profileblock.vue?vue&type=script&lang=js"
export * from "./profileblock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports